<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header pb-0">
            <div class="d-flex justify-content-between">
                <div class="d-grid gap-2 d-flex">
                  <!-- <button 
                      v-if="certificate && certificate.state == 'Draft'"
                      class="btn btn-xs btn-outline-secondary text-xs font-weight-normal m-0">
                      <i class="fa fa-pencil-square-o" aria-hidden="true"></i> Edit
                  </button> -->
                  <!-- <button 
                      @click="validate"
                      class="btn btn-xs btn-primary text-xs font-weight-normal m-0"
                      v-if="certificate && certificate.state == 'Draft'">
                      <i class="fa fa-check" aria-hidden="true"></i> Validate
                  </button> -->
                  <button 
                      @click="submit"
                      class="btn btn-xs btn-primary text-xs font-weight-normal m-0"
                      v-if="certificate && certificate.state == 'Draft'">
                      <i class="fa fa-check" aria-hidden="true"></i> Submit
                  </button>
                  <button 
                    @click="download"
                    :class="'btn btn-xs btn-outline-primary text-xs font-weight-normal m-0 ' + (loading ? 'disabled' : '')"
                    v-if="certificate && (certificate.state == 'Submitted' || certificate.state == 'Validated')">
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="loading"></span>
                    <i class="fa fa-download" v-if="!loading"></i> Download
                  </button>
                  <button 
                      @click="cancel"
                      class="btn btn-xs btn-outline-danger text-xs font-weight-normal m-0" 
                      v-if="certificate && (certificate.state == 'Submitted' || certificate.state == 'Draft')">
                      <i class="fa fa-times" aria-hidden="true"></i> Cancel
                  </button>
                  <!-- 
                  Di Disable Request 30/04/2024
                    <button 
                      @click="draft"
                      class="btn btn-xs btn-outline-primary text-xs font-weight-normal m-0" 
                      v-if="certificate && certificate.state == 'Cancelled'">
                      <i class="fa fa-reply" aria-hidden="true"></i> Set to Draft
                  </button> -->
                </div>
                <template v-if="certificate">
                    <argon-badge color="secondary" size="sm" class="text-xxs align-self-center" v-if="certificate.state == 'Draft'">{{ certificate.state }}</argon-badge>
                    <argon-badge color="info" size="sm" class="text-xxs align-self-center" v-if="certificate.state == 'Submitted'">{{ certificate.state }}</argon-badge>
                    <argon-badge color="success" size="sm" class="text-xxs align-self-center" v-if="certificate.state == 'Validated'">{{ certificate.state }}</argon-badge>
                    <argon-badge color="warning" size="sm" class="text-xxs align-self-center" v-if="certificate.state == 'Cancelled'">{{ certificate.state }}</argon-badge>
                </template>
            </div>
            <hr/>
        </div>
          <div class="card-body min-vh-50">
            <template v-if="certificate">
              <div class="row">
                <div class="col-lg-6 col-12 mb-3">
                  <h5>{{ certificate.number }}</h5>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-lg-6 col-12 mb-3">
                  <p class="text-uppercase text-sm">Vendor Information</p>
                  <div class="table-responsive">
                    <table class=" px-0" width="100%">
                      <tr class="px-0">
                        <td class="px-0 align-top" width="40%"><label class="my-0 text-secondary">Vendor Name</label></td>
                        <td class="px-0"><p class="text-sm text-dark font-weight-bold my-0">{{ certificate.partner_name }}</p></td>
                      </tr>
                      <tr class="px-0">
                        <td class="px-0 align-top" width="40%"><label class="my-0 text-secondary">Vendor Code</label></td>
                        <td class="px-0"><p class="text-sm text-dark font-weight-bold my-0">{{ certificate.partner_code }}</p></td>
                      </tr>
                      <tr class="px-0">
                        <td class="px-0 align-top" width="40%"><label class="my-0 text-secondary">NPWP</label></td>
                        <td class="px-0"><p class="text-sm text-dark font-weight-bold my-0">{{ certificate.partner_vat }}</p></td>
                      </tr>
                    </table>
                  </div>
                </div>
                <div class="col-lg-6 col-12 mb-3">
                  <p class="text-uppercase text-sm">Invoice Information</p>
                  <div class="table-responsive">
                    <table class=" px-0" width="100%">
                      <tr class="px-0">
                        <td class="px-0 align-top" width="40%"><label class="my-0 text-secondary">Invoice Number</label></td>
                        <td class="px-0"><p class="text-sm text-dark font-weight-bold my-0">{{ certificate.invoice_number }}</p></td>
                      </tr>
                      <tr class="px-0">
                        <td class="px-0 align-top" width="40%"><label class="my-0 text-secondary">Invoice Date</label></td>
                        <td class="px-0"><p class="text-sm text-dark font-weight-bold my-0">{{ certificate.invoice_date }}</p></td>
                      </tr>
                      <tr class="px-0">
                        <td class="px-0 align-top" width="40%"><label class="my-0 text-secondary">Bill Status</label></td>
                        <td class="px-0"><p class="text-sm text-dark font-weight-bold my-0">{{ certificate.bill_state }}</p></td>
                      </tr>
                      <tr class="px-0">
                        <td class="px-0 align-top" width="40%"><label class="my-0 text-secondary">Payment Status</label></td>
                        <td class="px-0"><p class="text-sm text-dark font-weight-bold my-0">{{ certificate.payment_state }}</p></td>
                      </tr>
                      <tr class="px-0">
                        <td class="px-0 align-top" width="40%"><label class="my-0 text-secondary">Payment Date</label></td>
                        <td class="px-0"><p class="text-sm text-dark font-weight-bold my-0">{{ certificate.payment_date }}</p></td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-6 col-12 mb-3">
                  <p class="text-uppercase text-sm">Faktur Information</p>
                  <div class="table-responsive">
                    <table width="100%">
                      <tbody>
                        <tr>
                          <td width="40%"><label class="text-secondary my-0">Faktur Number</label></td>
                          <td><p class="text-sm text-dark font-weight-bold my-0">{{ certificate.faktur_number }}</p></td>
                        </tr>
                        <tr>
                          <td><label class="text-secondary my-0">Faktur Date</label></td>
                          <td><p class="text-sm text-dark font-weight-bold my-0">{{ certificate.faktur_date }}</p></td>
                        </tr>
                        <tr>
                          <td><label class="text-secondary my-0">Total Amount</label></td>
                          <td><p class="text-sm text-dark font-weight-bold my-0">{{ certificate.amount_untaxed }}</p></td>
                        </tr>
                        <tr>
                          <td><label class="text-secondary my-0">PPN</label></td>
                          <td><p class="text-sm text-dark font-weight-bold my-0">{{ certificate.amount_ppn }}</p></td>
                        </tr>
                        <tr>
                          <td><label class="text-secondary my-0">Total Amount + PPN</label></td>
                          <td><p class="text-sm text-dark font-weight-bold my-0">{{ certificate.amount_with_ppn }}</p></td>
                        </tr>
                        <tr>
                          <td><label class="text-secondary my-0">Labor</label></td>
                          <td><p class="text-sm text-dark font-weight-bold my-0">{{ certificate.amount_labor }}</p></td>
                        </tr>
                        <tr>
                          <td><label class="text-secondary my-0">PPH (Without PPh)</label></td>
                          <td><p class="text-sm text-dark font-weight-bold my-0">{{ certificate.amount_pph }}</p></td>
                        </tr>
                        <tr>
                          <td><label class="text-secondary my-0">Total Payment</label></td>
                          <td><p class="text-sm text-dark font-weight-bold my-0">{{ certificate.amount_total }}</p></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="col-lg-6 col-12 mb-3">
                  <p class="text-uppercase text-sm">URLs and Files</p>
                  <div class="mb-3">
                    <table class="px-0" width="100%">
                      <tr class="px-0">
                        <td class="px-0 align-top" width="40%"><label class="my-0 text-secondary">Invoice File</label></td>
                        <td class="px-0">
                          <button 
                            type="button" 
                            class="text-sm btn-link btn p-0 m-0" 
                            @click="downloadAttachment(certificate.id,'sk.certificate.invoice','invoice_file',certificate.invoice_file_name)">
                            <i class="fa fa-download"></i> {{ certificate.invoice_file_name }}
                          </button>
                        </td>
                      </tr>
                      <tr class="px-0">
                        <td class="px-0 align-top" width="40%"><label class="my-0 text-secondary">Faktur File</label></td>
                        <td class="px-0">
                          <button 
                            type="button" 
                            class="text-sm btn-link btn p-0 m-0" 
                            @click="downloadAttachment(certificate.id,'sk.certificate.invoice','faktur_file',certificate.faktur_file_name)">
                            <i class="fa fa-download"></i> {{ certificate.faktur_file_name }}
                          </button>
                        </td>
                      </tr>
                      <tr class="px-0">
                        <td class="px-0 align-top" width="40%"><label class="my-0 text-secondary">Efaktur URL</label></td>
                        <td class="px-0">
                          <a :href="certificate.faktur_url" class="text-primary text-sm" target="_blank"><i class="fa fa-external-link"></i> Open</a>
                        </td>
                      </tr>
                    </table>
                  </div>
                  <p class="text-uppercase text-sm">Delivery Notes Information</p>
                  <div class="table-responsive">
                    <table class="table table-bordered">
                      <thead class="text-xs bg-light">
                        <th class="ps-2 text-center" width="5%">#</th>
                        <th class="ps-2">Project</th>
                        <th class="ps-2">Delivery Notes</th>
                        <th class="ps-2">Amount (Rp)</th>
                      </thead>
                      <tbody class="text-xs">
                        <tr v-for="line,i in certificate.line_ids" :key="line.project_id">
                          <td class="text-center">{{ i+1 }}</td>
                          <td>{{ line.project_name }}</td>
                          <td class="break-column">{{ line.delivery_notes_name }}</td>
                          <td class="break-column">Rp. {{ line.amount }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ArgonBadge from "@/components/ArgonBadge.vue";
const endpoint = require("../router/endpoint");

export default {
  name: "certificate-detail",
  components: {
    ArgonBadge
  },
  data() {
    return {
      loading: false,
      certificate: null,
      edit: false,
    };
  },
  methods: {
    getCertificateDetail() {
      this.loading = true
      this.axios
        .post(
          endpoint.CERTIFICATE_DETAIL,
          {
            certificate_id: this.$route.params.id,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`
            }
          }
        )
        .then((response) => {
          if (response.data.response_code === "0000") {
            this.certificate = response.data.data;
          } else {
            this.$notify({
              type: 'warn',
              title: 'Warning',
              text: response.data.message,
            });
          }
          this.loading = false
        })
        .catch((e) => {
          this.$notify({
              type: 'error',
              title: 'Failed',
              text: e.response.data.message,
            });
          this.loading = false;
        });
    },
    validate() {
      this.loading = true
      this.axios
        .post(
          endpoint.CERTIFICATE_VALIDATE,
          {
            id: this.$route.params.id,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`
            }
          }
        )
        .then((response) => {
          if (response.data.response_code === "0000") {
            // this.certificate = response.data.data;
            this.getCertificateDetail()
          } else {
            this.$notify({
              type: 'warn',
              title: 'Warning',
              text: response.data.message,
            });
          }
          this.loading = false
        })
        .catch((e) => {
          this.$notify({
              type: 'error',
              title: 'Failed',
              text: e.response.data.message,
            });
          this.loading = false;
        });
    },
    submit() {
      this.loading = true
      this.axios
        .post(
          endpoint.CERTIFICATE_SUBMIT,
          {
            id: this.$route.params.id,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`
            }
          }
        )
        .then((response) => {
          if (response.data.response_code === "0000") {
            // this.certificate = response.data.data;
            this.getCertificateDetail()
          } else {
            this.$notify({
              type: 'warn',
              title: 'Warning',
              text: response.data.message,
            });
          }
          this.loading = false
        })
        .catch((e) => {
          this.$notify({
              type: 'error',
              title: 'Failed',
              text: e.response.data.message,
            });
          this.loading = false;
        });
    },
    cancel() {
      this.loading = true
      this.axios
        .post(
          endpoint.CERTIFICATE_CANCEL,
          {
            id: this.$route.params.id,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`
            }
          }
        )
        .then((response) => {
          if (response.data.response_code === "0000") {
            // this.certificate = response.data.data;
            this.getCertificateDetail()
          } else {
            this.$notify({
              type: 'warn',
              title: 'Warning',
              text: response.data.message,
            });
          }
          this.loading = false
        })
        .catch((e) => {
          this.$notify({
              type: 'error',
              title: 'Failed',
              text: e.response.data.message,
            });
          this.loading = false;
        });
    },
    draft() {
      this.loading = true
      this.axios
        .post(
          endpoint.CERTIFICATE_DRAFT,
          {
            id: this.$route.params.id,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`
            }
          }
        )
        .then((response) => {
          if (response.data.response_code === "0000") {
            // this.certificate = response.data.data;
            this.getCertificateDetail()
          } else {
            this.$notify({
              type: 'warn',
              title: 'Warning',
              text: response.data.message,
            });
          }
          this.loading = false
        })
        .catch((e) => {
          this.$notify({
              type: 'error',
              title: 'Failed',
              text: e.response.data.message,
            });
          this.loading = false;
        });
    },
    download () {
      this.loading = true
      this.axios
        .post(
          endpoint.DOWNLOAD,
          {
            res_id: this.$route.params.id,
            template_report: 'bh_sanko_certificate_invoice.action_report_certificate_invoice'
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`
            }
          }
        )
        .then((response) => {
          if (response.data.response_code === "0000") {
            const linkSource = `data:application/pdf;base64,${response.data.data.file}`;
            const downloadLink = document.createElement("a");
            const fileName = this.certificate.number + ".pdf";
            downloadLink.href = linkSource;
            downloadLink.download = fileName;
            downloadLink.click();
          } else {
            if (response.data.response_code !== "4000"){
              this.$notify({
                type: 'warn',
                title: 'Warning',
                text: response.data.message,
              });
            }
          }
          this.loading = false
        })
        .catch((e) => {
          this.loading = false;
          this.$notify({
              type: 'error',
              title: 'Something went wrong!',
              text: e.response.data.message,
            });
        });
    },
    downloadAttachment (id,model,field,filename) {
      // this.loading = true
      const values = {
          res_id: id,
          res_model: model,
          res_field: field,
      }
      this.axios
          .post(
          endpoint.GET_ATTACHMENT_BINARY,
          values,
          {
              headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`
              }
          }
          )
          .then((response) => {
            if (response.data.response_code === "0000") {
                const linkSource = `data:${response.data.data.mimetype};base64,${response.data.data.file}`;
                const downloadLink = document.createElement("a");
                const fileName = filename;
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
            } else {
                this.$notify({
                    type: 'warn',
                    title: 'Warning',
                    text: response.data.message,
                });
            }
            this.loading = false
          })
          .catch((e) => {
          this.loading = false;
          this.$notify({
              type: 'error',
              title: 'Something went wrong!',
              text: e.response.data.message,
              });
          });
    }
  },
  mounted() {
    this.getCertificateDetail()
  }
};
</script>

<style>

</style>